import { apiClient } from '@/lib/api-client';

/**
 * Ops simulation T08 — the customer's linked credit account, read by the
 * payment screen to offer "Account Credit". Amounts in minor units.
 */
export interface CustomerCreditAccount {
  id: string;
  customer_id: string;
  customer_name: string;
  /** 0 means the account has no limit. */
  credit_limit: number;
  outstanding_balance: number;
  /** credit_limit − outstanding; null when there is no limit. */
  available: number | null;
}

export const creditAccountService = {
  /**
   * The customer's active credit account, or null when they have none. The
   * endpoint is gated by the credit-billing flag and plan, so a 403 also means
   * "not offered" — callers treat any failure the same way.
   */
  getForCustomer(customerId: string) {
    return apiClient<CustomerCreditAccount | null>(
      `/credit-accounts/customer/${encodeURIComponent(customerId)}`,
    );
  },
};
